"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class AnalyticsApi extends runtime.BaseAPI {
    /**
     * Submit log statement to the backend
     */
    async submitLogRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling submitLog.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/reporting/logging`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.LogEntryToJSON(requestParameters.logEntry),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentCreatedFromJSON(jsonValue));
    }
    /**
     * Submit log statement to the backend
     */
    async submitLog(requestParameters) {
        const response = await this.submitLogRaw(requestParameters);
        return await response.value();
    }
}
exports.AnalyticsApi = AnalyticsApi;
//# sourceMappingURL=AnalyticsApi.js.map